import { FunctionComponent } from 'react';
import { FiX } from 'react-icons/fi';

interface ChitProps {
  name: string;
  onDeleteCallback: (name: string) => void;
}

const Chit: FunctionComponent<ChitProps> = ({ name, onDeleteCallback }) => {
  return (
    <div
      onClick={() => onDeleteCallback(name)}
      className="cursor-pointer border w-fit p-2 rounded-lg border-gray-200 flex items-center space-x-2 text-gray-400"
    >
      <FiX /> <span className="font-light">{name}</span>
    </div>
  );
};

export default Chit;
